export enum SafetyIntxType {
  THREE_LEG_MINOR_STOP = "THREE_LEG_MINOR_STOP",
  THREE_LEG_ALL_STOP = "THREE_LEG_ALL_STOP",
  THREE_LEG_SIGNAL = "THREE_LEG_SIGNAL",
  FOUR_LEG_MINOR_STOP = "FOUR_LEG_MINOR_STOP",
  FOUR_LEG_ALL_STOP = "FOUR_LEG_ALL_STOP",
  FOUR_LEG_SIGNAL = "FOUR_LEG_SIGNAL",
  THREE_LEG_ROUNDABOUT = "THREE_LEG_ROUNDABOUT",
  FOUR_LEG_ROUNDABOUT = "FOUR_LEG_ROUNDABOUT",
  DIAMOND_WITH_SIGNALS = "DIAMOND_WITH_SIGNALS",
  DIAMOND_WITH_STOP_CONTROL = "DIAMOND_WITH_STOP_CONTROL",
  DIAMOND_WITH_ONE_LANE_ROUNDABOUTS = "DIAMOND_WITH_ONE_LANE_ROUNDABOUTS",
}

export enum CrashSeverity {
  FATAL_INJURY = "FATAL_INJURY",
  TOTAL = "TOTAL",
  PDO = "PDO",
}

export enum TurnControlType {
  SIGNAL = "SIGNAL",
  STOP = "STOP",
  YIELD = "YIELD",
  MERGE = "MERGE",
  FREE = "FREE",
}

export enum SafetyFacilityType {
  TWO_LANE_RURAL_ROADWAY = "TWO_LANE_RURAL_ROADWAY",
  RURAL_MULTILANE_HIGHWAY = "RURAL_MULTILANE_HIGHWAY",
  URBAN_SUBURBAN_COLLECTOR = "URBAN_SUBURBAN_COLLECTOR",
  URBAN_SUBURBAN_ARTERIAL = "URBAN_SUBURBAN_ARTERIAL",
  RAMP_TERMINAL = "RAMP_TERMINAL",
}

export enum PennDotDistricts {
  DISTRICT_1 = "DISTRICT_1",
  DISTRICT_2 = "DISTRICT_2",
  DISTRICT_3 = "DISTRICT_3",
  DISTRICT_4 = "DISTRICT_4",
  DISTRICT_5 = "DISTRICT_5",
  DISTRICT_6 = "DISTRICT_6",
  // DISTRICT_7 = "DISTRICT_7", there is no district 7
  DISTRICT_8 = "DISTRICT_8",
  DISTRICT_9 = "DISTRICT_9",
  DISTRICT_10 = "DISTRICT_10",
  DISTRICT_11 = "DISTRICT_11",
  DISTRICT_12 = "DISTRICT_12",
}
interface Road {
  aadt: number;
  hasCrosswalk?: boolean;
  hasExclusiveLeft?: boolean;
  hasExclusiveRight?: boolean;
  speedLimit?: number;
}

interface RoadWithSpeedLimit extends Road {
  speedLimit: number;
}

export interface AtGradeIntxTypes {
  intxType: SafetyIntxType;
  facilityType: SafetyFacilityType;
  skewAngle?: number;
  majorRoad: Road;
  minorRoad: Road;
  pennDotDistrict: PennDotDistricts;
  county: string;
}

export interface UrbanSubIntxTypes extends AtGradeIntxTypes {
  majorRoad: RoadWithSpeedLimit;
  minorRoad: RoadWithSpeedLimit;
}
export interface TwoLaneRuralIntxTypes extends UrbanSubIntxTypes {
  skewAngle: number;
}

export interface AtGradeExpectedIntxTypes extends AtGradeIntxTypes {
  yearsOfAnalysis: number;
  observedTotalCrashes: number;
  observedFatalInjuryCrashes: number;
}

export interface AtGradeExpectedIntxTypesTwoLaneRural
  extends TwoLaneRuralIntxTypes {
  yearsOfAnalysis: number;
  observedTotalCrashes: number;
  observedFatalInjuryCrashes: number;
}

export interface AtGradeExpectedIntxTypesUrbanSub extends UrbanSubIntxTypes {
  yearsOfAnalysis: number;
  observedTotalCrashes: number;
  observedFatalInjuryCrashes: number;
}

export interface SpfExportTypes {
  getFatalInjuryPredicted: (props: any) => number;
  getTotalPredicted: (props: any) => number;
  getPDOPredicted?: (props: any) => number;
  getFatalInjuryExpected: (props: any) => number;
  getTotalExpected: (props: any) => number;
}

export type NumThrulanes = 2 | 3 | 4 | 5 | 6;

export enum AreaType {
  URBAN = "URBAN",
  RURAL = "RURAL",
}

export interface AADTs {
  aadtin: number;
  aadtout: number;
  aadtex: number;
  aadten: number;
}

export type CrashSeverityFiOrTotal =
  | CrashSeverity.FATAL_INJURY
  | CrashSeverity.TOTAL;

export type IntxTypeSignalOrStop =
  | SafetyIntxType.DIAMOND_WITH_SIGNALS
  | SafetyIntxType.DIAMOND_WITH_STOP_CONTROL;

export interface RoundaboutRampSpfType extends AADTs {
  areaType: AreaType;
  crashSeverity: CrashSeverity;
  intxType: SafetyIntxType.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS;
  observedFatalInjuryCrashes: number;
  observedTotalCrashes: number;
  yearsOfAnalysis: number;
}

interface RampTerminal extends AADTs {
  areaType: AreaType;
  bothApproachesNumThruLanes: NumThrulanes;
  crossroadMedianWidth: number;
  distanceToAdjacentRampTerminal: number;
  distanceToPublicStreetIntx: number;
  exitRampApproachNumLanes: number;
  exitRampApproachRightTurnControlType: TurnControlType;
  insideApproachWidthOfLaneOrBay: number;
  intxType: IntxTypeSignalOrStop;
  // | SafetyIntxType.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS; TODO create separate ramp terminals object for roundabouts
  isInsideApproachLaneOrBayPresent: boolean;
  isOutsideApproachLaneOrBayPresent: boolean;
  observedFatalInjuryCrashes: number;
  observedTotalCrashes: number;
  yearsOfAnalysis: number;
}

interface SignalizedRampTerminalBase extends RampTerminal {
  insideApproachNumThruLanes: number;
  intxType: SafetyIntxType.DIAMOND_WITH_SIGNALS;
  isExitRampApproachChannelized: boolean;
  isInsideApproachProtectedOnlyMode: boolean;
  isNonRampPublicStreetPresent: boolean;
  isOutsideApproachChannelized: boolean;
  numOutsideCrossroadLegDriveways: number;
  numOutsideCrossroadPublicStreetApproaches: number;
}

export interface SignalizedRampTerminal extends SignalizedRampTerminalBase {
  crashSeverity: CrashSeverity.PDO | CrashSeverity.FATAL_INJURY;
}

interface StopControlRampTerminalBase extends RampTerminal {
  exitRampSkewAngle: number;
  intxType: SafetyIntxType.DIAMOND_WITH_STOP_CONTROL;
}

export interface StopControlRampTerminal extends StopControlRampTerminalBase {
  crashSeverity: CrashSeverity.PDO | CrashSeverity.FATAL_INJURY;
}

export type SignalOrStopRampTerminal =
  | SignalizedRampTerminal
  | StopControlRampTerminal;
